import { render } from "./AddGifts.vue?vue&type=template&id=93e49d9e&scoped=true"
import script from "./AddGifts.vue?vue&type=script&lang=js"
export * from "./AddGifts.vue?vue&type=script&lang=js"

import "./AddGifts.vue?vue&type=style&index=0&id=93e49d9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e49d9e"]])

export default __exports__